const numberWithCommas = (value) => {
	let str = String(value)

    return str.split('').reduce(
        (a, b, i) => a + (i && !((str.length - i) % 3) ? ',' : '') + b,
        ''
    )
};

export default numberWithCommas;
